import { render, staticRenderFns } from "./wallmodal.vue?vue&type=template&id=4cb28e92"
import script from "./wallmodal.vue?vue&type=script&lang=js"
export * from "./wallmodal.vue?vue&type=script&lang=js"
import style0 from "./wallmodal.vue?vue&type=style&index=0&id=4cb28e92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports